export default __webpack_public_path__ + "static/media/load.b75b820d.gif";